var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_227_1160",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 38
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_227_1160)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -2,
    width: 41,
    height: 40,
    fill: "#5B5B5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_227_1160",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_227_1160",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAAAXNSR0IArs4c6QAAAyhJREFUeF7tnM2uTEEUhb87YELcKeIVmHBD8AriBZgxwANcJgZMmBMSiQGegGfwE4y8AzH2M2FAKroTfdNHn7XvqX26jtXjffaq+mr17jq7K7WBPykENlJULIJBJ5nAoA06iUCSjB1t0EkEkmTsaINOIpAkY0cbdBKBJBk7ugHQe4HLwAXgKLAvaczZMt+BD8Az4BHwMzKAqKMPAS+A4xHRhp95D5wDPqtziIAuTn71H0Kes30HnFGdHQF9DbinrujE4q8CD5Q5RUC/AU4qIhOMfQ2cVuYVAf0V2K+ITDC2MDigzCsC+leHQCSXMtaxYgeZbwTOIMJjUQvoDjJfg15N3qBXMxokwqAHwbg6iUGvZjRIRDOgy5vkbeAiUF7dlc8n4ClwE/jR8WDt/M2AvgNsK3SXxN4FrnfkqJ2/GdDFlaqTdzItTZyuHLXzNwO6a6Cqybu2omPll7bGUvCMjLrCY4GovZASOynYoBfWTmInBRu0QatlYlm8+hsgmVQKtqPtaDsa8K4DQgfRvb378/2Ryq4U7BrtGu0a7RodqDPB0vEROLxLy5UcRzpy1M6v/iYtHWZGjR6ijVly3KjYJv1X/mZAl8b8rVnjX3V238Z/zfzNgN5l1Rj9cYNOWgKDNugkAkkydrRBJxFIkmnG0bXPXdTO3wzoIV5YfK7jr69v11tm7XMXtfM342g3/tXmdbCpZNAG3auR79Kx4hum7v583GBGTAVh0CoBg14ktm6OU9dTHb/0p4kU7F1Hrx/P0f7K8vbO27teDvX2ztu7xSrl0pFUOmqfu6idv5nSMUSb1Oc6erRJfa4jqXSoLw7rFt9M6Vg3cOp4DFolFow36CA49TGDVokF4w06CE59bDTQvo4NvgCbyopF2qTlcr1TisgEY8uVoeXazN6fCOhyXeT93grTDLwCPFSmFgFd3vReAicUoQnFvgXOZlwCW5gdBJ4DWxMC2GcqBfL5rGuN5wPaA1yaXdR9bML3lX6bXdT9BHisOnkOK1I6+qy8Y3YQMOgkSxi0QScRSJKxow06iUCSjB1t0EkEkmTsaINOIpAkY0cbdBKBJJnfk+v+W1LM90gAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.da6c04cad0bb4666c33b8fac3483d23d.svg";
export { ForwardRef as ReactComponent };